import { render, staticRenderFns } from "./framework.vue?vue&type=template&id=4467711d&scoped=true&"
import script from "./framework.vue?vue&type=script&lang=ts&"
export * from "./framework.vue?vue&type=script&lang=ts&"
import style0 from "./framework.vue?vue&type=style&index=0&id=4467711d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4467711d",
  null
  
)

export default component.exports